export const TestId = {
    BACK_BUTTON: 'back-button',
    WEATHER_CARD: 'weather-card',
};
